import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IGetPatientSurgeryParams, ISurgery } from '~/interfaces'
import { fetchPatientSurgery, message } from '~/services'

const UNIQUE_KEY = 'surgery'

export const useFetchSurgery = (
  fetchParams: IGetPatientSurgeryParams | null,
  config?: UseQueryOptions<ISurgery, Error, ISurgery>
): UseQueryResult<ISurgery, Error> => {
  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchPatientSurgery(fetchParams)

      return response
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError?.code === '404') {
        throw new Error(message('detailsMedicalEvents.emptyResponseFetched'))
      }
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<ISurgery, Error>([UNIQUE_KEY, fetchParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    ...config
  })
}
